module.exports = __webpack_public_path__ + "static/media/27-3.3e45c4eb.mp3";